import {map$} from '../stores/store-map.ts';
import {monitorLoadingError} from './obsoleteApi.ts';

export function planLazyLoadingMapRelatedComponents() {
  const subscription = map$.subscribe((map) => {
    if (map) {
      monitorLoadingError(import('../elements/element-layers.ts'));
      monitorLoadingError(import('../elements/element-poi-popup.ts'));
      monitorLoadingError(import('../elements/element-sightseeing-details.ts'));
      monitorLoadingError(
        import('../elements/element-travelreport-details.ts'),
      );
      monitorLoadingError(import('../elements/element-place-details.ts'));
      monitorLoadingError(import('../elements/element-big-gallery.ts'));
      subscription.unsubscribe();
    }
  });
}
